stimulusApp.register(
  "switch-locale",
  class extends Stimulus.Controller {
    actualize(event) {
      const link = event.currentTarget
      link.search = this.#buildSearch()
    }

    actualizeSelect(event) {
      let url = new URL(event.target.value)
      url.search = this.#buildSearch()
      window.location.href = url
    }

    #buildSearch() {
      const params = new URLSearchParams(window.location.search)

      params.append("force_locale", "true")

      return params.toString()
    }
  },
)
